var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32 27.851h4.707c1.109.001 1.663.001 2.158-.136a3.555 3.555 0 0 0 1.448-.84c.377-.36.65-.837 1.188-1.778l.017-.028 6.106-10.794c.542-.948.81-1.424.93-1.925a3.54 3.54 0 0 0 0-1.658c-.119-.497-.39-.97-.924-1.903l-.013-.023-2.39-4.171c-.495-.87-.745-1.305-1.06-1.466a1.2 1.2 0 0 0-1.085 0c-.316.16-.567.596-1.061 1.466L2.717 25.086c-.489.858-.733 1.287-.715 1.639.025.381.221.727.543.936.298.191.787.191 1.776.191zm23.343.001h-6.746c-.996.001-1.496.001-1.788-.19a1.208 1.208 0 0 1-.544-.94c-.017-.35.23-.775.722-1.626l.011-.02 3.367-5.78c.494-.853.744-1.276 1.054-1.437.34-.173.74-.173 1.08 0 .308.157.547.562 1.022 1.364v.002l.039.065 3.38 5.781.049.084h-.001c.467.809.706 1.22.69 1.561-.02.381-.222.733-.543.942-.298.196-.8.196-1.794.196z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/AVAX.7371419bf6423062a883be368757de79.svg";
export { ForwardRef as ReactComponent };